import { useEffect, useState } from 'react'

// Chrome on Android offers its own install prompt through `beforeinstallprompt`,
// which can fire before React mounts, so it is caught at import time and kept.
// iOS never fires it: there the Get started card explains Share, Add to Home Screen.

interface InstallEvent extends Event {
  prompt: () => Promise<void>
}

let deferred: InstallEvent | null = null
const listeners = new Set<() => void>()

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', e => {
    e.preventDefault()
    deferred = e as InstallEvent
    listeners.forEach(l => l())
  })
  window.addEventListener('appinstalled', () => {
    deferred = null
    listeners.forEach(l => l())
  })
}

/** Shows the browser's install prompt, or null where the browser doesn't offer one. */
export function useInstallPrompt(): (() => Promise<void>) | null {
  const [, force] = useState(0)
  useEffect(() => {
    const l = () => force(n => n + 1)
    listeners.add(l)
    return () => { listeners.delete(l) }
  }, [])
  if (!deferred) return null
  const event = deferred
  return async () => {
    await event.prompt()
    deferred = null
    listeners.forEach(l => l())
  }
}
